/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { TradeAuthorityOfficeControllerService } from './services/trade-authority-office-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    TradeAuthorityOfficeControllerService,
    ApiConfiguration
  ],
})
export class CustomersTrade_authority_officeModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersTrade_authority_officeModule> {
    return {
      ngModule: CustomersTrade_authority_officeModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersTrade_authority_officeModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersTrade_authority_officeModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
